module.exports = __webpack_public_path__ + "media/images/icons/italic-3261de92ba4d08b82c0846572e733774.svg";